import styled, { css } from "styled-components";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

import ElectricBoltOutlinedIcon from "@mui/icons-material/ElectricBoltOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import StarIcon from "@mui/icons-material/Star";

// import {
//   getAllGenerateHistory,
//   getGenerateHistoryBySeller,
// } from "src/api/generateHistory";

import font from "src/styles/font";
import device from "src/styles/device";
import {
  Black,
  DarkGrey,
  Grey,
  Primary,
  White,
  White01,
} from "src/styles/color";
import { convertIntToCurrency } from "src/common";

import Button from "src/components/core/Button";
import Chip from "src/components/core/Chip";

const WrapperHeaderFixed = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const HeaderFixed = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 24px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media ${device.tabletL} {
    padding: 16px 20px;
  }
`;

const HeaderItem = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  /* align-self: ${({ alignSelf }) => (alignSelf ? alignSelf : "unset")}; */
  gap: 16px;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 40px 24px;
`;

const WrapperTable = styled.div`
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.1);

  @media ${device.tabletL} {
    overflow-x: auto;
  }
`;

const Table = styled.div`
  width: 100%;
  border-radius: 24px;
  background-color: ${White};
  border: 1px solid ${White01};
  overflow: hidden;
  /* box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.1); */

  @media ${device.tabletL} {
    min-width: 730px;
  }
`;

const TableTitle = styled.div`
  width: 100%;
  padding: 24px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: ${font.size.lg};
  font-weight: 600;
  border-bottom: 1px solid ${White01};
  background-color: #f9fafb;
`;

const TableHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${White01};
  background-color: #f9fafb;
`;

const TableHeaderItem = styled.div`
  flex: 1;
  padding: 16px 24px;
  font-size: ${font.size.md};

  ${({ title }) =>
    title
      ? css`
          font-weight: 500;
          color: ${DarkGrey};
        `
      : css`
          font-weight: 600;
          /* text-align: center; */
          color: ${Black};
        `}
`;

const TableRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid ${White01};
  }
`;

const TableItem = styled.div`
  flex: 1;
  padding: 16px 24px;
  font-size: ${font.size.md};
  display: flex;
  align-items: center;
  /* justify-content: center; */
  gap: 8px;

  ${({ title, highlight, special }) =>
    title
      ? css`
          font-weight: 300;
          color: ${DarkGrey};
        `
      : highlight
        ? css`
            font-weight: 600;
            color: ${Primary};
          `
        : special
          ? css`
              font-weight: 400;
              font-size: ${font.size.sm};
              color: #9810fa;
            `
          : css`
              font-weight: 400;
              color: ${Black};
            `}
`;

const SelectPackage = ({ packageInfoList, handleSelectPackage }) => {
  const chipColors = [
    "default",
    "secondary",
    "info",
    "primary",
    "success",
    "warning",
    "error",
  ];
  return (
    <>
      <WrapperHeaderFixed>
        <HeaderFixed>
          <HeaderItem>
            <Typography variant="h5" fontWeight={600}>
              เติม Token เพื่อสร้างสรรค์ผลงาน AI
            </Typography>
          </HeaderItem>
        </HeaderFixed>
      </WrapperHeaderFixed>

      <Container>
        <Grid container columnSpacing={2} rowSpacing={6}>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              fontWeight={500}
              sx={{ textAlign: "center" }}
            >
              เลือกแพ็คเกจที่เหมาะกับความต้องการของคุณ
              ไม่ว่าจะเป็นผู้เริ่มต้นหรือร้านค้ามืออาชีพ
              เรามีตัวเลือกที่คุ้มค่าที่สุดสำหรับทุกธุรกิจ
            </Typography>
          </Grid>

          {/* package card */}
          {packageInfoList.map((pkg, index) => (
            <Grid item xs={6} md={3} key={`package-${pkg?._id}`}>
              <Card
                sx={{
                  borderRadius: 4,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  ...(pkg.is_popular
                    ? {
                        position: "relative",
                        border: `2px solid ${Primary}`,
                        overflow: "visible",
                        boxShadow: "0 8px 12px rgba(0, 0, 0, 0.1)",
                        transform: "scale(1.03)",
                      }
                    : {}),
                }}
              >
                {pkg.is_popular && (
                  <Chip
                    label="ยอดนิยม"
                    color="primary"
                    sx={{
                      position: "absolute",
                      top: -16,
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  />
                )}

                <CardContent sx={{ p: 3 }}>
                  <Chip
                    variant="secondary"
                    color={chipColors[index % chipColors.length]}
                    label={pkg.name}
                  />
                  <Typography
                    variant="h4"
                    fontWeight={600}
                    gutterBottom
                    sx={{ marginTop: 2 }}
                  >
                    {convertIntToCurrency(pkg.price, false)}.-
                  </Typography>

                  <Typography variant="body2">{`"${pkg.title}"`}</Typography>

                  <Stack
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                  >
                    <Box
                      sx={{
                        p: 1.5,
                        background: "#FEF2F2",
                        borderRadius: 4,
                        height: 48,
                      }}
                    >
                      <ElectricBoltOutlinedIcon sx={{ color: "#FB2C36" }} />
                    </Box>

                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {convertIntToCurrency(pkg.total_token, false)} Tokens
                      </Typography>
                      <Typography
                        variant="body2"
                        color={Grey}
                        sx={{ fontSize: font.size.sm }}
                      >
                        เฉลี่ย {(pkg.price / pkg.total_token).toFixed(2)} บาท /
                        Token
                      </Typography>
                    </Box>
                  </Stack>

                  <Stack
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                  >
                    <Box
                      sx={{
                        p: 1.5,
                        background: "#EFF6FF",
                        borderRadius: 4,
                        height: 48,
                      }}
                    >
                      <AccessTimeOutlinedIcon sx={{ color: "#2B7FFF" }} />
                    </Box>

                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        อายุการใช้งาน {pkg.expiry_days} วัน
                      </Typography>
                    </Box>
                  </Stack>

                  <Stack
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    sx={{ marginTop: 2, marginBottom: 2 }}
                  >
                    <Box
                      sx={{
                        p: 1.5,
                        background: "#F0FDF4",
                        borderRadius: 4,
                        height: 48,
                      }}
                    >
                      <ArticleOutlinedIcon sx={{ color: "#00C950" }} />
                    </Box>

                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        ประมาณ {pkg.estimated_image_min}-
                        {pkg.estimated_image_max} รูป
                      </Typography>
                    </Box>
                  </Stack>

                  {pkg.unlimited_text ? (
                    <Stack
                      spacing={2}
                      direction="row"
                      alignItems="center"
                      sx={{ marginTop: 2, marginBottom: 2 }}
                    >
                      <Box
                        sx={{
                          p: 1.5,
                          background: "#FAF5FF",
                          borderRadius: 4,
                          height: 48,
                        }}
                      >
                        <AutoAwesomeOutlinedIcon sx={{ color: "#AD46FF" }} />
                      </Box>

                      <Box>
                        <Typography
                          variant="subtitle1"
                          fontWeight={600}
                          color="#8200DB"
                        >
                          เขียนข้อความฟรีไม่จำกัด
                        </Typography>
                      </Box>
                    </Stack>
                  ) : null}
                </CardContent>

                <CardActions sx={{ p: 3, pt: 0 }}>
                  <Button
                    variant={pkg.is_popular ? "contained" : "dark"}
                    fullWidth
                    onClick={() => handleSelectPackage(pkg)}
                  >
                    ซื้อตอนนี้
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}

          {/* package detail table */}
          <Grid item xs={12}>
            <WrapperTable>
              <Table>
                <TableTitle>
                  <VerifiedUserOutlinedIcon sx={{ color: "#00C950" }} />
                  เปรียบเทียบสิทธิประโยชน์
                </TableTitle>

                <TableHeader>
                  <TableHeaderItem title>หัวข้อเปรียบเทียบ</TableHeaderItem>

                  {packageInfoList.map((pkg) => (
                    <TableHeaderItem>{pkg.name}</TableHeaderItem>
                  ))}
                </TableHeader>

                <TableRow>
                  <TableItem title>ราคาขาย (รวม VAT)</TableItem>

                  {packageInfoList.map((pkg) => (
                    <TableItem>
                      {convertIntToCurrency(pkg.price, false)}.-
                    </TableItem>
                  ))}
                </TableRow>

                <TableRow>
                  <TableItem title>Token ที่ได้รับ</TableItem>

                  {packageInfoList.map((pkg) => (
                    <TableItem highlight>
                      {convertIntToCurrency(pkg.total_token, false)}
                      {/* {convertIntToCurrency(pkg.token_amount, false)}
                        <span>
                          +{convertIntToCurrency(pkg.bonus_token, false)}
                        </span> */}
                    </TableItem>
                  ))}
                </TableRow>

                <TableRow>
                  <TableItem title>อายุการใช้งาน</TableItem>

                  {packageInfoList.map((pkg) => (
                    <TableItem>{pkg.expiry_days} วัน</TableItem>
                  ))}
                </TableRow>

                <TableRow>
                  <TableItem title>ราคาเฉลี่ย / Token</TableItem>

                  {packageInfoList.map((pkg) => (
                    <TableItem>
                      {(pkg.price / pkg.total_token).toFixed(2)} บาท
                    </TableItem>
                  ))}
                </TableRow>

                <TableRow>
                  <TableItem title>จำนวนสินค้าที่ผลิตได้</TableItem>

                  {packageInfoList.map((pkg) => (
                    <TableItem>
                      {pkg.estimated_image_min}-{pkg.estimated_image_max} ชิ้น
                    </TableItem>
                  ))}
                </TableRow>

                <TableRow>
                  <TableItem title>สิทธิพิเศษ</TableItem>

                  {packageInfoList.map((pkg) => (
                    <>
                      {pkg?.unlimited_text ? (
                        <TableItem special>
                          <StarIcon sx={{ color: "#9810FA", mr: 1 }} />
                          เขียนข้อความฟรีไม่จำกัด
                        </TableItem>
                      ) : (
                        <TableItem>-</TableItem>
                      )}
                    </>
                  ))}
                </TableRow>
              </Table>
            </WrapperTable>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SelectPackage;
